import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="bg-muted/50 border-t border-border py-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          <div className="flex items-center gap-3" />

          <nav className="flex flex-wrap items-center justify-center gap-6 text-sm text-muted-foreground">
            <Link to="/#produkte" className="hover:text-foreground transition-colors">Produkte</Link>
            <Link to="/#vorteile" className="hover:text-foreground transition-colors">Vorteile</Link>
            <Link to="/#ueber-uns" className="hover:text-foreground transition-colors">Über uns</Link>
            <Link to="/#faq" className="hover:text-foreground transition-colors">FAQ</Link>
            <Link to="/#kontakt" className="hover:text-foreground transition-colors">Kontakt</Link>
            <span className="hidden md:inline text-border">|</span>
            <Link to="/impressum" className="hover:text-foreground transition-colors">Impressum</Link>
            <Link to="/datenschutz" className="hover:text-foreground transition-colors">Datenschutz</Link>
          </nav>
        </div>

        <div className="mt-8 pt-6 border-t border-border text-center">
          <p className="text-xs text-muted-foreground">
            © {new Date().getFullYear()} Successio Unternehmensnachfolge GmbH. Alle Rechte vorbehalten.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
